import { render, staticRenderFns } from "./DerbyRace.vue?vue&type=template&id=4b272358&scoped=true&"
import script from "./DerbyRace.vue?vue&type=script&lang=js&"
export * from "./DerbyRace.vue?vue&type=script&lang=js&"
import style0 from "./DerbyRace.vue?vue&type=style&index=0&id=4b272358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b272358",
  null
  
)

export default component.exports